import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CardContainer from '../components/CardContainer'
import { Container, Row, Col } from 'react-bootstrap'
import { Loading } from '../components/Loading'
import ErrorPage from './ErrorPage';
import { getMoviesNow } from '../store/action/index'

function Home() {
    const dispatch = useDispatch()
    const movies = useSelector(state => state.moviesNow)
    const loading = useSelector(state => state.loading)
    const error = useSelector(state => state.error)

    useEffect(() => {
        dispatch(getMoviesNow())
    }, [])

    if(loading) return <Loading/>
    if(error) return <ErrorPage/>
    return (
        <>
            <Container>
                <Row>
                    <Col xs={6} md={12}>
                        <CardContainer movies={ movies.data } title={ 'Now Playing' }/>
                    </Col>
                </Row>
            </Container>
        </>
    )

}

export default Home